import { render, staticRenderFns } from "./wwe-thanisch.vue?vue&type=template&id=436673a4&scoped=true"
import script from "./wwe-thanisch.vue?vue&type=script&lang=js"
export * from "./wwe-thanisch.vue?vue&type=script&lang=js"
import style0 from "./wwe-thanisch.vue?vue&type=style&index=0&id=436673a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436673a4",
  null
  
)

export default component.exports